import * as actions from '../actions/ChargeEvent';

const initialState = {
  billErrorDtoList: [],
  error: false,
  status: 200,
  error_message: ''
};

const stripeChargeEvents = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_STRIPE_CHARGE_EVENT_SUCCESS:
      return Object.assign({}, state, action.payload);
    case actions.GET_STRIPE_CHARGE_EVENT_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default stripeChargeEvents;
